// extracted by mini-css-extract-plugin
module.exports = {"folder-description":"_1Doo2","folderDescription":"_1Doo2"};